<script lang="ts">
  import type { JobSkill } from "../../../app/store/store-careers";

  export let skill: JobSkill;

  function getTag(s: string) {
    return `<span class="font-medium leading-[1.7] text-primary-indigo-blue">${s}</span>`;
  }
</script>

<div
  class="flex-grow-0 flex-shrink-0 px-5 py-2 rounded-[40px] bg-primary-indigo-blue bg-opacity-[0.06] tracking-[0.02em]"
>
  {#if typeof skill === "string"}
    {@html getTag(skill)}
  {:else if Array.isArray(skill)}
    <div class="multiple-skill">
      {#each skill as s}
        {@html getTag(s)}
      {/each}
    </div>
  {:else}
    {@html getTag(skill.skill)}

    {#if skill.moreInfo}
      <span class="italic font-medium text-primary-indigo-blue text-opacity-50"
        >{skill.moreInfo}</span
      >
    {/if}
  {/if}
</div>

<style lang="postcss">
  .multiple-skill :global(span:not(:last-child)::after) {
    @apply italic font-medium text-primary-indigo-blue text-opacity-50;
    content: " | ";
  }
</style>
